import { SetLocationModal } from "./SetLocationModal";

export default SetLocationModal;
